module.exports = __webpack_public_path__ + "static/media/dec1306.cc9ba65b.png";